import { useState } from 'react';
import { Outlet } from '@tanstack/react-router';
import TourPageHeader from '@/features/dashboard/tours/components/TourPageHeader.tsx';
import TourCreatedDialog from '@/features/dashboard/tours/components/TourCreatedDialog.tsx';
import { tourRoute } from '@/features/dashboard/tours/routes/tourRoute.ts';

/**
 * Szkielet ekranu wyjazdu: nagłówek, tagi i modal powitalny. Treść wnosi
 * zakładka — każda ma własny segment ścieżki i własny route potomny.
 *
 * Tagi siedzą w nagłówku, nie w zakładce, bo dotyczą całego wyjazdu, a nie
 * jednego jego przekroju.
 */
const TourDetailsPage = () => {
  const { justCreated } = tourRoute.useSearch();

  const [isTourJustCreatedModal, setIsTourJustCreatedModal] = useState(
    justCreated === true,
  );

  return (
    <div className="space-y-4">
      <TourPageHeader />
      <Outlet />

      {isTourJustCreatedModal && (
        <TourCreatedDialog onClose={() => setIsTourJustCreatedModal(false)} />
      )}
    </div>
  );
};

export default TourDetailsPage;
